import React from 'react';

export const ClusterHome = React.lazy(() => import('./pages/ClusterHome'));
export const OwiHome = React.lazy(() => import('./pages/OwiHome'));
